import { useState } from 'react';

/**
 * Custom hook for managing StudentDashboard state
 * Centralizes state management for preferences form and other dashboard states
 * @returns {Object} State values and setters
 */
export const useStudentDashboardState = () => {
  const [showPreferencesForm, setShowPreferencesForm] = useState(false);



  return {
    showPreferencesForm,
    setShowPreferencesForm
  };
};

export default useStudentDashboardState;